module.exports = __webpack_public_path__ + "r-v3/img/ml_31_01.9d6f2556.jpg";